import { AppState } from '@reducers/rootReducer';
import type { ContactInfoType, ReduxAction } from '../../types';
import { OrderedSet } from 'immutable';

export interface SourceLabelsState {
  email: OrderedSet<string>;
  phone: OrderedSet<string>;
}

const initialSourceLabelsState = {
  email: OrderedSet<string>(),
  phone: OrderedSet<string>(),
};

const selectEmailSourceLabels = (appState: AppState) => appState.ui.sourceLabels.email;
const selectPhoneSourceLabels = (appState: AppState) => appState.ui.sourceLabels.phone;

export const selectCustomSourceLabels = (sourceType: ContactInfoType) => (appState: AppState) => {
  switch (sourceType) {
    case 'email':
      return selectEmailSourceLabels(appState);
    case 'phone':
      return selectPhoneSourceLabels(appState);
    default:
      return OrderedSet<string>();
  }
};

export function sourceLabelsReducer(
  state: SourceLabelsState = initialSourceLabelsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'LOAD_LOCAL_STORE_SUCCEEDED':
      const storedLabels = payload.get('source_labels');

      if (storedLabels) {
        return {
          email: storedLabels.email ? OrderedSet(storedLabels.email) : OrderedSet<string>(),
          phone: storedLabels.phone ? OrderedSet(storedLabels.phone) : OrderedSet<string>(),
        };
      }

      return state;

    case 'ADD_SOURCE_LABEL':
      return {
        ...state,
        [payload.sourceType]: state[payload.sourceType].add(payload.label),
      };

    case 'REMOVE_SOURCE_LABEL':
      return {
        ...state,
        [payload.sourceType]: state[payload.sourceType].delete(payload.label),
      };

    default:
      return state;
  }
}
